import {
  SET_BUSINESS_OWNER,
  SET_AVAILABLE_BUSINESS_OWNERS
} from 'constants/businessOwner';

export const setCurrentBusinessOwner = businessOwner => {
  return { type: SET_BUSINESS_OWNER, businessOwner };
};

export const setAvailableBusinessOwners = businessOwners => {
  return { type: SET_AVAILABLE_BUSINESS_OWNERS, businessOwners };
};
